import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 120 120"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M118.291 0c.946 0 1.713.767 1.713 1.713v116.575c0 .946-.767 1.712-1.713 1.712H1.713A1.71 1.71 0 0 1 0 118.288V1.713C0 .767.767 0 1.713 0zm-97.59 76.8a1.5 1.5 0 0 0-1.5 1.5v21a1.5 1.5 0 0 0 1.5 1.5h78.602a1.5 1.5 0 0 0 1.5-1.5l.001-11.4-.001-.02V78.3a1.5 1.5 0 0 0-1.5-1.5h-11.4a1.5 1.5 0 0 0-1.5 1.5v8.1H33.601v-8.1c0-.828-.673-1.5-1.501-1.5z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }